import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import {
  apiFolderFileLinks,
  DB_POSTFIX,
  removeDoubleSlas,
} from "../../../utils";

import { Link } from "react-router-dom";

import { ServiceUrl } from "../../../utils/serviceUrl";

import { Col, Row } from "react-bootstrap";
import PsContext from "../../../context";
import TopMenuLgOffcanvas from "./topMenuLgOffcanvas";
import SearchPage from "./SearchPage";

const TopMenu = (props) => {
  const context = useContext(PsContext);
  const [menus, setMenus] = useState([]);
  const [fullMenus, setFullMenus] = useState([]);
  const [loader, setLoader] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showFullMenus, setShowFullMenus] = useState(false);
  const [windowSize, setWindowSize] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      // Perform actions on window resize
      //setWindowSize([window.innerWidth, window.innerHeight]);
      setWindowSize(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setWindowSize(window.innerWidth);
  }, []);

  useEffect(() => {
    loadMenus();
  }, []);

  useEffect(() => {
    if (windowSize >= 1360) setMenus(fullMenus.slice(0, 12));
    else setMenus(fullMenus);
  }, [windowSize, fullMenus]);

  const loadMenus = () => {
    setLoader(true);
    axios
      .get(ServiceUrl.MENUS + "?sadb=" + DB_POSTFIX + "&type=website")
      .then((res) => {
        if (res["data"].status == "1") {
          setFullMenus(res["data"].data);
        }
        setLoader(false);
      });
  };

  useEffect(() => {
    window.onscroll = function () {
      myFunction();
    };

    // Get the navbar
    var navbar = document.getElementById("ps__top__menu");

    // Get the offset position of the navbar
    var sticky = navbar.offsetTop;

    // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position

    function myFunction() {
      if (window.scrollY >= (sticky || 150)) {
        navbar.classList.add("ps__top__menu__sticky");
      } else {
        navbar.classList.remove("ps__top__menu__sticky");
      }
    }
  }, []);

  const getSubMenu = (items) => {
    let rv = [];
    items.map((item, i) => {
      if (item.children && item.children.length > 0) {
        rv.push(
          <li className="dropdown">
            <a href="#">
              <span>{item.title}</span>
              <i className="fa-solid fa-chevron-down"></i>
            </a>
            <ul>{getSubMenu(item.children)}</ul>
          </li>
        );
      } else {
        if (item.linktype == "external") {
          rv.push(
            <li>
              <a target="_blank" href={item.menulink}>
                {getMenuText(item)}
              </a>
            </li>
          );
        } else {
          rv.push(
            <li>
              <Link className="" to={removeDoubleSlas("/" + item.menulink)}>
                {getMenuText(item)}
              </Link>
            </li>
          );
        }
      }
    });
    return rv;
  };

  const getMenuText = (item) => {
    return isRegionalLanguage() && item.title_tam ? (
      <span className="text_unicode">{item.title_tam}</span>
    ) : (
      item.title
    );
  };

  const getMenu = (item) => {
    let rv = [];

    if (item.children && item.children.length > 0) {
      rv.push(
        <li className="dropdown">
          <a href="#" className="first_link">
            <span>{getMenuText(item)}</span>
            <i className="fa-solid fa-chevron-down"></i>
          </a>
          <ul>{getSubMenu(item.children)}</ul>
        </li>
      );
    } else {
      if (item.linktype == "external") {
        rv.push(
          <li>
            <a
              target="_blank"
              className="nav-link  first_link"
              href={item.menulink}
            >
              {getMenuText(item)}
            </a>
          </li>
        );
      } else {
        rv.push(
          <li>
            <Link
              className="nav-link  first_link"
              to={removeDoubleSlas("/" + item.menulink)}
            >
              {getMenuText(item)}
            </Link>
          </li>
        );
      }
    }
    return rv;
  };

  const isRegionalLanguage = () => {
    return context.isRegionalLanguage();
  };

  const updateRegionalLang = (lang) => {
    context.setRegionalLanguage(lang);
  };

  let maxVisibleMenus = 10;

  if (windowSize >= 2000) {
    maxVisibleMenus = 18;
  } else if (windowSize >= 1800) {
    maxVisibleMenus = 16;
  } else if (windowSize >= 1600) {
    maxVisibleMenus = 14;
  } else if (windowSize >= 1440) {
    maxVisibleMenus = 12;
  } else if (windowSize >= 1360) {
    maxVisibleMenus = 10;
  } else if (windowSize >= 1200) {
    maxVisibleMenus = 8;
  } else if (windowSize >= 992) {
    maxVisibleMenus = 6;
  } else if (windowSize >= 768) {
    maxVisibleMenus = 4;
  } else {
    maxVisibleMenus = 2;
  }

  return (
    <>
      <div className="ps__top__menu bg-light py-2" id="ps__top__menu">
        <nav id="navbar" className="navbar order-last order-lg-0 ">
          <ul className="top__menu ms-auto me-auto">
            {fullMenus
              .slice(0, maxVisibleMenus)
              .map((item, i) => getMenu(item))}

            {context.settingValue("web_site_multi_lang") == "1" ? (
              isRegionalLanguage() ? (
                <li className="lang-li-box">
                  <a
                    onClick={() => updateRegionalLang("english")}
                    className="nav-link first_link"
                  >
                    En
                  </a>
                </li>
              ) : (
                <li className="lang-li-box">
                  <a
                    className="nav-link first_link text_unicode"
                    onClick={() => updateRegionalLang("tamil")}
                  >
                    தமிழ்
                  </a>
                </li>
              )
            ) : null}

            {fullMenus.length > maxVisibleMenus && (
              <li>
                <a
                  className="nav-link first_link"
                  onClick={() => setShowFullMenus(!showFullMenus)}
                >
                  <i
                    className="fa-solid fa-bars"
                    style={{ fontSize: "16px" }}
                  ></i>
                </a>
              </li>
            )}
          </ul>
          <div className="d-md-none d-sm-block container">
            <Row>
              <Col xs={10} className="p-0">
                <span class="logo me-auto">
                  <img
                    src={apiFolderFileLinks(
                      context.settingValue("web_site_top_logo")
                    )}
                    style={{ width: "100%" }}
                  />
                </span>
              </Col>
              <Col
                xs={2}
                className="d-flex justify-content-center align-items-center"
              >
                <div>
                  <a
                    className="nav-link text-black pt-1 pe-3"
                    onClick={(e) => setShowFullMenus(!showFullMenus)}
                  >
                    <i
                      className="fa-solid fa-bars"
                      style={{ fontSize: "25px" }}
                    ></i>
                  </a>
                </div>
              </Col>
            </Row>
          </div>
        </nav>
      </div>
      <TopMenuLgOffcanvas
        show={showFullMenus}
        onHideClick={(e) => setShowFullMenus(false)}
        menus={fullMenus}
      />
    </>
  );
};

export default TopMenu;
